import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import OrganizePdf from './Components/OrganizePdf.vue';
import CompressPdf from './Components/CompressPdf.vue';

const app = createApp({
    components: {
        OrganizePdf,
        CompressPdf
    },
});
app.mount('#app');
